import React from 'react'
import { usePostRequest } from '../../../hooks/request'
import { TOTAL_EXPENSE_CATEGORY_LIST } from '../../../urls'
import { useMessage } from '../../../hooks/message'
import TotalExpenseCategoryForm from './TotalExpenseCategoryForm'

export default function TotalExpenseCategoryCreate({ onSuccess, onCancel }) {
    const brandCreate = usePostRequest({ url: TOTAL_EXPENSE_CATEGORY_LIST })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const { success } = await brandCreate.request({ data })

        if (success) {
            showMessage('Успешно сохранен', 'is-success')
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Қўшиш</b>
            </h1>

            <TotalExpenseCategoryForm loading={brandCreate.loading} onSubmit={onSubmit} onCancel={onCancel} />
        </div>
    )
}
